// extracted by mini-css-extract-plugin
export default {"instruments":"ToolsDIR_instruments__NKY-W","dataSettings":"ToolsDIR_dataSettings__UCX0p","latLonInputs":"ToolsDIR_latLonInputs__hGCw2","inputsRow":"ToolsDIR_inputsRow__DYU63"};